<div class="list-group">
  @for (asset of sortedAssets(); track asset; let index = $index) {
    <ml-mdm-vpp-asset-list-item-ui #item
                                   class="list-group-item list-group-item-action"
                                   [class.active]="selectedIndex === index"
                                   [asset]="asset"
                                   (click)="select(index)"></ml-mdm-vpp-asset-list-item-ui>
  }
</div>